import { getBookingColours } from "@calcom/lib/getBookingColours";
import useGetBrandingColours from "@calcom/lib/getBrandColours";
import useTheme from "@calcom/lib/hooks/useTheme";
import { useCalcomTheme } from "@calcom/ui/styles";

export const useBrandColors = ({
  brandColor,
  darkBrandColor,
  bookingTheme,
  theme,
}: {
  brandColor?: string;
  darkBrandColor?: string;
  /** Per-section booking colour overrides (see @calcom/lib/bookingTheme). */
  bookingTheme?: unknown;
  theme?: string | null;
}) => {
  const brandTheme = useGetBrandingColours({
    lightVal: brandColor,
    darkVal: darkBrandColor,
  });

  // Section overrides are layered on top of the brand colours; any colour not
  // customized keeps inheriting the brand via CSS fallbacks in tokens.css.
  const sectionColours = getBookingColours(bookingTheme);

  useCalcomTheme({
    light: { ...brandTheme.light, ...sectionColours.light },
    dark: { ...brandTheme.dark, ...sectionColours.dark },
  });
  useTheme(theme);
};
